export default __webpack_public_path__ + "static/media/aws_cp.1d4d9fa2.png";